"use strict";

const strf = require("./string.format.js");

class MetaStreamIOUser {
  constructor({
    constants = null,
    logger = null,
    id = null,
    ciam_id = null,
    email_id = null,
    country = null,
  } = {}) {
    this.constant = constants;
    this.logger = logger;
    this.set(id);
    this.setCountry(country);
    this.setCiam(ciam_id);
    this.setEmail(email_id);
  }

  reset() {
    this.set();
    this.setCiam();
    this.setDeviceToken();
    this.setEmail();
  }

  set(id = null) {
    if (id !== null) {
      this.id = id;
    } else {
      this.id = this.constant.MetaStreamIO_User_Guest;
    }

    this.logger.log(
      "user",
      this.constant.MetaStreamIO_Log_UserIdSet.format(this.id)
    );
  }

  setCiam(id = null) {
    this.ciam_id = id;
    this.logger.log(
      "user",
      this.constant.MetaStreamIO_Log_CIAMIdSet.format(this.ciam_id)
    );
  }

  setCountry(country = null) {
    this.country = country;
    this.logger.log(
      "user",
      this.constant.MetaStreamIO_Log_UserCountrySet.format(this.country)
    );
  }

  setDeviceToken(device_token = null) {
    this.device_token = device_token;
    this.logger.log(
      "user",
      this.constant.MetaStreamIO_Log_PushDeviceTokenSet.format(
        this.device_token
      )
    );
  }

  setEmail(email = null) {
    this.email_id = email;
    this.logger.log(
      "user",
      this.constant.MetaStreamIO_Log_EmailIdSet.format(this.email_id)
    );
  }
}

module.exports = MetaStreamIOUser;
